var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoltStackBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 610.97,
    height: 358.46,
    viewBox: "0 0 610.97 358.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#011b33;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bolt Stack Blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "427.69 269.51 491.1 269.51 491.1 0 427.69 13.47 427.69 269.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.55,76.54a97.85,97.85,0,1,0,97.85,97.85A97.85,97.85,0,0,0,310.55,76.54Zm0,129.55a31.71,31.71,0,1,1,31.71-31.7A31.71,31.71,0,0,1,310.55,206.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.55,295.05a31.71,31.71,0,1,0,31.71,31.71A31.71,31.71,0,0,0,310.55,295.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.36,12.42A83.12,83.12,0,0,0,98.64,0H0V269.51H111A83.27,83.27,0,0,0,169.46,127,83.25,83.25,0,0,0,142.36,12.42Zm-78.86,51H98.73a19.82,19.82,0,0,1,0,39.64H63.5Zm47.56,142.68H63.5V166.46h47.56a19.82,19.82,0,1,1,0,39.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M596.79,219.48c-12.68,0-17.52-11.1-17.52-26.16V143.56h31.62V80.15H579.18V31.71L515.77,45.18V209.27c0,38.66,24,60.94,59.45,62.79.35,0,.79.09,1.14.09H577c.79,0,1.49.09,2.29.09h.79A65.33,65.33,0,0,0,611,264.31V217.63A52.63,52.63,0,0,1,596.79,219.48Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltStackBlue);
export default __webpack_public_path__ + "static/media/Bolt-Stack-Blue.1b3e279ac640ea28bbeccdb4aee903ab.svg";
export { ForwardRef as ReactComponent };